import { RedoMarketplaceProductFieldType } from "@redotech/crdb-enums/product/redo-marketplace-product-field-type";
import { RedoMarketplaceVariantFieldType } from "@redotech/crdb-enums/product/redo-marketplace-variant-field-type";
import { redoMarketplaceListingIdFormat } from "@redotech/redo-marketplace-id";
import { attributeDefinitionIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const RedoMarketplaceListingIdWithStatusSchema = z.object({
  id: redoMarketplaceListingIdFormat.schema,
});
export type RedoMarketplaceListingIdWithStatus = z.infer<
  typeof RedoMarketplaceListingIdWithStatusSchema
>;

const RedoMarketplaceProductMappingSchema_ = z.object({
  fieldName: z.enum(RedoMarketplaceProductFieldType),
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
});
export const RedoMarketplaceProductMappingSchema: z.ZodType<RedoMarketplaceProductMapping> =
  RedoMarketplaceProductMappingSchema_;
export interface RedoMarketplaceProductMapping extends z.infer<
  typeof RedoMarketplaceProductMappingSchema_
> {}

const RedoMarketplaceVariantMappingSchema_ = z.object({
  fieldName: z.enum(RedoMarketplaceVariantFieldType),
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
});
export const RedoMarketplaceVariantMappingSchema: z.ZodType<RedoMarketplaceVariantMapping> =
  RedoMarketplaceVariantMappingSchema_;
export interface RedoMarketplaceVariantMapping extends z.infer<
  typeof RedoMarketplaceVariantMappingSchema_
> {}

export const RedoMarketplaceMappingSchema_ = z.object({
  productMappings: z.array(RedoMarketplaceProductMappingSchema).readonly(),
  variantMappings: z.array(RedoMarketplaceVariantMappingSchema).readonly(),
});
export const RedoMarketplaceMappingSchema: z.ZodType<RedoMarketplaceMapping> =
  RedoMarketplaceMappingSchema_;
export interface RedoMarketplaceMapping extends z.infer<
  typeof RedoMarketplaceMappingSchema_
> {}
